import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

import CloseIcon from "@material-ui/icons/Close";
import { updateAppInfo } from "actions/appInfo";
import { useDispatch, useSelector } from "react-redux";
import AppHelper from "helpers/AppHelper";
import useStyles from "./style";
import LabelInput from "components/Base/LabelInput";
import { alertActions } from "actions/alert.actions";
import DialogActions from "@material-ui/core/DialogActions";
import ActionButton from "routing/AppInfoPage/TermsAndConditions/components/ActionButton";

interface SetupPricingProps {
  setStep?: (step: number) => void;
  user?: any;
}
export const SetupPricing = (props: SetupPricingProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    register,
    setValue,
    getValues,
    watch,
    errors,
    setError,
    clearErrors,
  } = useForm();
  const [checkBlurPrice, setCheckBlurPrice] = useState("");

  useEffect(() => {
    if (props?.user) {
      if (
        props?.user?.fee_subscription_monthly > 0 ||
        props?.user?.fee_subscription_annual > 0
      ) {
        setValue("subcriptionFee", true);
      }
      setValue("priceMonthly", props?.user?.fee_subscription_monthly || 0);
      setValue("priceAnnual", props?.user?.fee_subscription_annual || 0);
    }
  }, [props?.user]);

  const onHandleCloseModal = () => {
    AppHelper.hideGlobalModal();
  };

  const onCancelClicked = (e: any) => {
    e.preventDefault();
    AppHelper.hideGlobalModal();
  };

  const handleUpdate = async (e: any) => {
    e.preventDefault();
    await dispatch(
      updateAppInfo({
        fee_subscription_monthly: getValues("priceMonthly"),
        fee_subscription_annual: getValues("priceAnnual"),
      })
    );
    AppHelper.hideGlobalModal();
  };

  const onBlurSubcriptionFee = () => {
    if (getValues("priceMonthly") < 0) {
      setError("priceMonthly", {
        message: "Invalid value. Value must be greater than 0",
      });
      return;
    } else if (
      !new RegExp(/^[+-]?\d+(\.\d+)?$/).test(getValues("priceMonthly"))
    ) {
      setError("priceMonthly", { message: "Invalid value." });
      return;
    }
    if (!errors?.priceMonthly && !errors?.priceAnnual) {
      if (
        parseFloat(getValues("priceMonthly")) !==
        props?.user?.fee_subscription_monthly
      ) {
        setCheckBlurPrice("priceMonthly");
      }
    }
  };

  // const onBlurPriceAnnual = () => {
  //     if (getValues('priceAnnual') === '') {
  //       setValue('priceAnnual', 0)
  //     }
  //     if (getValues('priceAnnual') < 0) {
  //       setError('priceAnnual', { message: 'Invalid value. Value must be greater than 0' })
  //       return
  //     }
  //     else if (!(new RegExp(/^[+-]?\d+(\.\d+)?$/).test(getValues('priceAnnual')))) {
  //       setError('priceAnnual', { message: 'Invalid value.' })
  //       return
  //     }
  //     if (!errors?.priceMonthly && !errors?.priceAnnual) {
  //       if (parseFloat(getValues('priceAnnual')) !== props?.user?.fee_subscription_annual) {
  //         setCheckBlurPrice('priceAnnual');
  //       }
  //     }
  // };

  return (
    <>
      <div className={classes.bodyModalList}>
        <div className={classes.headerContent}>
          <div className={classes.contentTitle}>Add a membership fee</div>
          <div className={classes.iconCloseIcon} onClick={onHandleCloseModal}>
            <CloseIcon />
          </div>
        </div>
        <div className={classes.contentSubTitle}>
          Customers will have access to Brik modules they’ve already started.
          Membership fees will apply to your customers who have not yet started
          Brik modules part of the membership.
        </div>
        <div className={classes.viewPriceFee}>
          <LabelInput
            isPrice
            label="Monthly membership"
            ref={register({})}
            name="priceMonthly"
            customClass={classes.priceMonthly}
            onBlur={onBlurSubcriptionFee}
            errors={errors?.priceMonthly}
            maxLength={9}
            cypressId="cypress-membership-price-input-field"
          />
          {/* <LabelInput
                    isPrice
                    label='Annual Price'
                    optional={true}
                    ref={register({})}
                    name='priceAnnual'
                    customClass={classes.priceAnnual}
                    onBlur={onBlurPriceAnnual}
                    errors={errors?.priceAnnual}
                    maxLength={9}
                /> */}
        </div>
        <p className={classes.typeTitle}>
          ***Any updated membership fees will be applied to your customers on
          their next billing statement. We advise not to make too many changes
          in a short period of time.
        </p>

        <DialogActions className={classes.buttonContainer}>
          <ActionButton
            bgColor="#D2D2D2"
            label="Back"
            handleClose={onCancelClicked}
            cypressId="cypress-back-modal-button"
          />
          <ActionButton
            type="submit"
            bgColor="#0C85F4"
            textColor="#FFFFFF"
            label="Apply"
            handleClose={handleUpdate}
            isNext={true}
             cypressId="cypress-apply-modal-button"
          />
        </DialogActions>
      </div>
    </>
  );
};
